import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane, FaWhatsapp } from 'react-icons/fa';
import './ContactForm.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        country: '',
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const response = await fetch('https://savisaconsultant.vercel.app/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setSubmitStatus('success');
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    country: '',
                    message: ''
                });
            } else {
                setSubmitStatus('error');
                console.error('Submission failed:', data);
            }
        } catch (error) {
            console.error('Submission error:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
            setTimeout(() => setSubmitStatus(null), 5000);
        }
    };

    const countries = [
        'United Kingdom',
        'United States',
        'Canada',
        'Australia',
        'Germany',
        'New Zealand'
    ];

    return (
        <section className="contact-section section">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="section-title"
                >
                    <h2>
                        Get In <span className="gradient-text">Touch</span>
                    </h2>
                    <p>Ready to start your study abroad journey? Contact us today!</p>
                </motion.div>

                <div className="contact-content">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="contact-info"
                    >
                        <div className="info-card card">
                            <h3>Let's Talk About Your Future</h3>
                            <p>
                                Our expert counselors are here to guide you through every step
                                of your study abroad journey. Reach out to us and let's make
                                your dreams a reality.
                            </p>

                            <div className="contact-details">
                                <div className="detail-item">
                                    <div className="detail-icon">
                                        <FaPhone />
                                    </div>
                                    <div className="detail-content">
                                        <h4>Phone</h4>
                                        <p>+968 9524 9020</p>
                                        <p>+968 7809 5244</p>
                                    </div>
                                </div>

                                <div className="detail-item">
                                    <div className="detail-icon">
                                        <FaEnvelope />
                                    </div>
                                    <div className="detail-content">
                                        <h4>Email</h4>
                                        <p>savisaconsultant080@gmail.com</p>
                                    </div>
                                </div>

                                <div className="detail-item">
                                    <div className="detail-icon">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div className="detail-content">
                                        <h4>Office</h4>
                                        <p>105, Algubhara</p>
                                        <p>Muscat, Oman</p>
                                    </div>
                                </div>
                            </div>

                            <div className="social-links">
                                <h4>Connect With Us</h4>
                                <div className="social-buttons">
                                    <a
                                        href="https://wa.me/96895249020"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-btn whatsapp"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <FaWhatsapp /> WhatsApp
                                    </a>
                                    <a
                                        href="mailto:savisaconsultant080@gmail.com"
                                        className="social-btn email"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <FaEnvelope /> Email
                                    </a>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        className="contact-form-wrapper"
                    >
                        <form onSubmit={handleSubmit} className="contact-form card">
                            <h3>Send Us a Message</h3>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="name">Full Name *</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        placeholder="John Doe"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email">Email Address *</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="john@example.com"
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="phone">Phone Number *</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        placeholder="+92 300 1234567"
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="country">Preferred Destination *</label>
                                    <select
                                        id="country"
                                        name="country"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a country</option>
                                        {countries.map((country, index) => (
                                            <option key={index} value={country}>
                                                {country}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Your Message *</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    rows="5"
                                    placeholder="Tell us about your study abroad goals..."
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary submit-btn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner"></span>
                                        Sending...
                                    </>
                                ) : (
                                    <>
                                        Send Message <FaPaperPlane />
                                    </>
                                )}
                            </button>

                            {submitStatus === 'success' && (
                                <motion.div
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    className="success-message"
                                >
                                    ✓ Thank you! We'll get back to you soon.
                                </motion.div>
                            )}

                            {submitStatus === 'error' && (
                                <motion.div
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    className="error-message"
                                >
                                    ⚠ Something went wrong. Please try again or contact us directly.
                                </motion.div>
                            )}
                        </form>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default ContactForm;
